export type EmployeeReportStatus = 'open' | 'waiting_for_approval' | 'invoicing' | 'closed'

export type EmployeeReportStatusExtended = 'open' | 'waiting_for_approval' | 'invoicing' | 'closed' | 'all'

export const reportStatuses: {
  key: EmployeeReportStatus
  value: string
  secondary_value: string
}[] = [
  {
    key: 'open',
    value: 'Avoinna',
    secondary_value: 'Avoin'
  },
  {
    key: 'waiting_for_approval',
    value: 'Hyväksynnässä',
    secondary_value: 'Hyväksyntä'
  },
  {
    key: 'invoicing',
    value: 'Laskutuksessa',
    secondary_value: 'Laskutus'
  },
  {
    key: 'closed',
    value: 'Suljettu',
    secondary_value: 'Suljettu'
  }
]

export const reportStatusesExtended: {
  key: EmployeeReportStatusExtended
  value: string
}[] = [{ key: 'all', value: 'All' }, ...reportStatuses]
